import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import Meatballs from "Components/UI/Meatballs/Meatballs";
import { IIssue } from "Shared/Types/issue";

import styles from "./IssuesCalendar.module.scss";

export const useIssuesCalendar = () => {
  const [searchParams] = useSearchParams();

  type TOption = { issue: IIssue; status: string };

  const getMeatballOptions = (issues: TOption[]) => {
    const options = [];

    for (const issue of issues) {
      options.push({
        key: issue.issue.id,
        label: issue.issue.summary,
        icon: (
          <div className={styles[`rowCell__status_${issue.status}`]}>
            {issue.status}
          </div>
        ),
      });
    }

    return options;
  };

  const getDateLogicCircle = (
    row: any,
    column: any,
    onItemClick?: (id: string) => void,
  ) => {
    return row.issues?.map((el: any) => {
      if (column.date === el.day) {
        if (el.has_multi_issues) {
          return (
            <Meatballs<TOption>
              style={{ padding: 0 }}
              sx={{ padding: 0 }}
              key={el.day}
              onChange={(_, optionKey) => onItemClick?.(optionKey as string)}
              options={getMeatballOptions(el.issues)}
              value={el.issues[0]}
            >
              <div className={styles.itemCircle_multi} />
            </Meatballs>
          );
        } else {
          return el.status !== "none" ? (
            <div
              onClick={() => onItemClick?.(el.issue_id)}
              className={styles[`itemCircle_${el.status}`]}
            />
          ) : (
            <div className={styles.itemCircle_empty} />
          );
        }
      }
    });
  };

  const params = useMemo(
    () => ({
      vehicle: searchParams.get("issues_vehicle"),
      end_date: searchParams.get("issues_to"),
      start_date: searchParams.get("issues_from"),
    }),
    [searchParams],
  );

  return { getDateLogicCircle, params };
};
